import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import {
  SET_TRANSFERRED_FOR_TRANSPORT,
  SET_TRANSFERRED_FOR_TRANSPORT_SUCCESS,
  SET_TRANSFERRED_FOR_TRANSPORT_FAIL
} from '../redux/OffersDetails';

function* SetTransferredForTransportFlow({ payload: { hashId, description, }, }) {
  try {
    const endpoint = `${apiRoot}/transports`;
    const params = {
      offer_hash_id: hashId,
      description,
    };
    yield call(apiCall, { method: 'POST', endpoint, params, });
    yield put(SET_TRANSFERRED_FOR_TRANSPORT_SUCCESS());
  } catch (error) {
    yield put(SET_TRANSFERRED_FOR_TRANSPORT_FAIL(error));
  }
}

export default function* SetPickUpDateEasyTransport() {
  yield takeLatest(SET_TRANSFERRED_FOR_TRANSPORT, SetTransferredForTransportFlow);
}
